import logReducer, { defaultState } from "./logReducer";

export { defaultState };
export default logReducer;
